import { render, staticRenderFns } from "./Analisis_importe.vue?vue&type=template&id=bbea5d64"
import script from "./Analisis_importe.vue?vue&type=script&lang=js"
export * from "./Analisis_importe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports